/**
 * نام شرکت مشتری از client_details.company_name
 * توجه: فیلد تودرتوی company.company_name مربوط به شرکت CRM است و نباید استفاده شود.
 */
export const resolveClientCompanyName = (...sources) => {
  for (const src of sources) {
    if (!src || typeof src !== 'object') continue;
    const raw =
      src?.client?.client_details?.company_name
      ?? src?.clientdetails?.company_name
      ?? src?.client_details?.company_name
      // خود آبجکت client_details (دارای user_id)
      ?? (src?.user_id != null ? src.company_name : null)
      ?? null;
    const name = String(raw || '').trim();
    if (name) return name;
  }
  return null;
};

export const resolveClientPersonName = (client) => {
  if (!client) return null;
  const name = String(client.name_salutation || client.name || '').trim();
  return name || null;
};

/** نمایش «نام شخص · نام شرکت» در صورت وجود شرکت مشتری */
export const formatClientNameWithCompany = (...sources) => {
  let person = null;
  let company = null;
  for (const src of sources) {
    if (!src || typeof src !== 'object') continue;
    if (!person) {
      person = resolveClientPersonName(src.client) || resolveClientPersonName(src) || null;
    }
    if (!company) {
      company = resolveClientCompanyName(src);
    }
    if (person && company) break;
  }
  if (person && company) return `${person} · ${company}`;
  return person || company || null;
};
